import { SvgIcon } from "@tql/ui-components-react/kendo/common";
import {
	Card,
	CardBody,
	CardHeader,
} from "@tql/ui-components-react/kendo/layout";
import { Button } from "@tql/ui-components-react/tql/buttons";
import { bankNote_02 } from "@tql/ui-components-react/untitled/icons";

import type { ShipmentInsuranceOrPayVendor } from "~/shared/schemas/shipment-management-schema";
import { environmentConfig } from "~/shared/utils/environment-config.ts";
import { formatCurrency } from "~/shared/utils/string-fns.ts";

const openPayVendor = (poNumber: string) => {
	const payVendorEnv =
		{ local: "dev.", dev: "dev.", stage: "stg." }[
			environmentConfig.environmentName ?? ""
		] ?? "";
	window.open(
		`https://${payVendorEnv}finance.tql.com/FinanceUI/charges/${poNumber}`,
	);
};
export const VendorCard = ({
	details = { totalAmount: 0 },
	poNumber,
}: {
	details?: ShipmentInsuranceOrPayVendor;
	poNumber: string;
}) => {
	return (
		<div
			className={"half-size-card"}
			data-testid={"shipment-management-pay-vendor"}
		>
			<Card className={"full-height shipment-info-card"}>
				<CardHeader>
					<h3>Pay Vendor</h3>
				</CardHeader>
				<CardBody>
					<div className={"pay-vendor-details"}>
						<div className={"info-field"}>
							<div className={"section-label"}>Total Amount:</div>
							<div data-testid={"pay-vendor-total-amount"}>
								{formatCurrency(Number(details?.totalAmount ?? 0))}
							</div>
						</div>
						<Button
							onClick={() => openPayVendor(poNumber ?? "")}
							startIcon={<SvgIcon icon={bankNote_02} />}
							variant={"tertiary"}
						>
							Pay Vendor
						</Button>
					</div>
				</CardBody>
			</Card>
		</div>
	);
};
